var option_webview_default = {
  "option": "_6vCw2",
  "user_choice": "uG8MZ",
  "check": "_1FQVq",
  "image": "Gzqj7",
  "input": "_5i090",
  "title": "gx3RT",
  "centered": "UoQiK",
  "with_result": "CYknj",
  "list": "u2VwC",
  "with_image": "RqWPv",
  "progress": "f-ml9",
  "progress_value": "U2BB3",
  "label": "pfqC6",
  "cta": "GNkXL",
  "adornment_icon": "TYLlm",
  "remove": "tCDdp",
  "removeButton": "LnzVO",
  "removeButtonIcon": "odc91",
  "overlay": "I82qW",
  "shown": "fylhl",
  "dark": "_9gDGC",
  "spinner": "_10fxY",
  "spin": "IVKnH",
  "grid": "_5uIhh"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
